module.exports = __webpack_public_path__ + "img/carousel-1.b063d503.webp";